import { useAuth } from '@context/AuthProvider';
import { useDevelopmentModeToggle } from '@context/DevelopmentModeProvider';

export const useInDevMode = (): boolean => {
  const { currentUser } = useAuth();
  const { inDevMode } = useDevelopmentModeToggle();

  return inDevMode && !!currentUser?.isSuperAdmin;
};
